import { Button, Icon } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineEdit, AiOutlineWarning } from 'react-icons/ai';

import { useCurrentFeedback } from './hooks/useCurrentFeedback';
import { useFeedbackReview } from './hooks/useFeedbackReview';

export const FeedbackReviewButton = () => {
  const { t } = useTranslation();
  const { feedback } = useCurrentFeedback();
  const { handleReviewRequest, isLoading } = useFeedbackReview();

  const hasReview = React.useMemo(() => feedback?.reviewOn, [
    feedback?.reviewOn,
  ]);

  return (
    <Button
      isLoading={isLoading}
      variant="solid"
      onClick={handleReviewRequest}
      colorScheme={hasReview ? 'orange' : 'purple'}
      rightIcon={<Icon as={hasReview ? AiOutlineWarning : AiOutlineEdit} />}
    >
      {hasReview ? t('common.cancel_review') : t('common.request_review')}
    </Button>
  );
};
